import { SectionVM, TrascrizioneSeparazioneAtti } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneSeparazioneAtti = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataSepar?: SectionVM,
  dataEnteDichiarante?: SectionVM
): TrascrizioneSeparazioneAtti | undefined => {
  if (!(dataSection || dataSepar || dataEnteDichiarante?.judgmentPublicationDate)) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    tipoDichiarazione: dataSection?.typeRequest || undefined,
    flagNotificaDaPrivCittad: dataSection
      ? dataSection?.isReceivedPrivateCitizen
        ? '1'
        : '0'
      : undefined,
    trascrizione: dataSection?.templateTranscriptionText || undefined,
    dataComunicazione: dataSection?.dateTranscription
      ? dataSection?.dateTranscription.toFormat('yyyy-MM-dd')
      : undefined,
    idModificaMatrimonio:
      dataSection?.typeModificationMarriage || dataSepar?.typeModificationMarriage || undefined,
    dataPubblicazioneSentenza: dataEnteDichiarante?.judgmentPublicationDate
      ? dataEnteDichiarante?.judgmentPublicationDate.toFormat('yyyy-MM-dd')
      : undefined,
    dataDecorrenzaSentenza: dataEnteDichiarante?.effectiveDateSentence
      ? dataEnteDichiarante?.effectiveDateSentence.toFormat('yyyy-MM-dd')
      : undefined,
  };
};
